import AxiosAPI from "./AxiosAPI";

export const deleteAllReport = async (key) => {
  try {
    const response = await AxiosAPI.delete(
      `/reports/deleteallreport`
    );
    return response.data;
  } catch (err) {
    console.log(err);

  }
};

export const fetchDownloadReports = async (registrationId) => {
  try {
    const response = await AxiosAPI.get(`/report/downloadstatus/${registrationId}`);
    return response.data;
  } catch (error) {
    throw error
  }
};


export const handleAddReportConfig = async (data) => {
  try {
    const response = await AxiosAPI.post("/report/createreportconfig", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};



export const fetchReportConfig = async () => {
  try {
    const response = await AxiosAPI.get("/report/getreportconfigs");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
